<template>
  <teleport to="body">
    <div
      v-if="isModalActive"
      class="fixed inset-0 z-30 flex items-center justify-center bg-transparent"
    >
      <div
        class="fixed top-0 z-10 h-full w-full bg-dark-gray bg-opacity-50"
        @click="$emit('click-outside-modal')"
      />
      <div
        class="relative z-10 scroll-auto rounded-md bg-white p-4 md:p-6 lg:p-8"
        style="width: 550px"
      >
        <div class="flex items-center justify-between">
          <h3 class="text-left text-xl text-dark-blue md:text-2xl lg:text-3xl">
            Confirm your information
          </h3>
          <img
            class="mt-5"
            src="@/assets/highway-badge.svg"
            alt="Highway Badge"
          />
        </div>
        <form
          novalidate="novalidate"
          @submit.prevent="handleSubmit"
        >
          <div>
            <p class="mb-6 text-left text-base text-dark-gray">
              Let’s complete your profile.
            </p>
            <div>
              <div class="flex flex-col gap-2 text-left">
                <label
                  class="w-full text-left text-2xs font-bold uppercase text-dark-blue"
                  >Verified full name</label
                >
                <p class="mb-1 text-body-color">{{ fullName }}</p>
              </div>
              <form-field
                id="preferred_name"
                label="Preferred name (Required)"
                name="preferred_name"
                placeholder="Enter your preferred name"
                :value="preferredName"
                :error="full_name_error"
                :alert-message="full_name_alert"
                @input="handlePreferredName"
              />
            </div>
            <section class="flex w-full justify-end">
              <div class="flex w-1/2 justify-end">
                <button-main
                  class="mb-4 mt-3"
                  :disabled="false"
                  type="submit"
                  :loading-spinner="isLoading"
                  value="Continue"
                />
              </div>
            </section>
          </div>
        </form>
      </div>
    </div>
  </teleport>
</template>

<script setup>
import ButtonMain from '@/components/Button.vue';
import FormField from '@/components/FormField.vue';
import { useStore } from 'vuex';
import { ref, defineProps, onMounted, computed, watch } from 'vue';
import { toastResponse } from '@/common/handleServerResponse';

const store = useStore();
const isLoading = ref(false);
const preferredName = ref('');
defineProps({
  visible: Boolean,
});

onMounted(async () => {
  await store.dispatch('users/serverRefreshCurrentUser');
  const findInput = document.querySelector('#preferred_name');
  setTimeout(() => {
    findInput?.focus();
  }, 0);
});

const preferredNameStored = computed(() => currentUser.value?.preferred_name);
const currentUser = computed(() => store.state.users.currentUser);
const fullName = computed(
  () => `${currentUser.value?.first_name} ${currentUser.value?.last_name}`
);
const isEmailVerified = computed(() => currentUser.value?.is_verified_email);
const isModalActive = computed(
  () => store.state.identityVerification?.isPreferredNameModalActive
);

watch(preferredNameStored, (newVal) => {
  preferredName.value = newVal;
});
const handleSubmit = async () => {
  try {
    isLoading.value = true;
    let res = await store.dispatch(
      'users/updatePreferredName',
      preferredName.value
    );
    if (res.status == 200) {
      store.commit('identityVerification/setPreferredNameModal', false);
      if (!isEmailVerified.value) {
        store.commit('identityVerification/setIsCompanyEmailModal', true);
      }
    }
    isLoading.value = false;

    console.log(res);
  } catch (error) {
    toastResponse(error);
  }
};
const handlePreferredName = (event) => {
  preferredName.value = event.target.value;
};
</script>
